import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../common/Icon';
import TypingTerminal from './TypingTerminal';
import { prefersReducedMotion } from '../../utils/motion';

/**
 * Solution cards: a grid on desktop, a swipeable scroll-snap carousel on mobile.
 */
export default function SolutionsCarousel({ solutions, terminal }) {
  const trackRef = useRef(null);
  const [active, setActive] = useState(0);

  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    const middle = track.scrollLeft + track.clientWidth / 2;
    let closest = 0;
    let best = Infinity;
    Array.from(track.children).forEach((card, index) => {
      const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle);
      if (distance < best) {
        best = distance;
        closest = index;
      }
    });
    setActive(closest);
  };

  const goTo = (index) => {
    const track = trackRef.current;
    const card = track?.children[index];
    if (!card) return;
    track.scrollTo({
      left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  };

  return (
    <>
      <div className="home-solutions" ref={trackRef} onScroll={handleScroll}>
        {solutions.map((item, index) => (
          <Link
            key={item.title}
            to={item.href}
            className={`home-solution ${item.featured ? 'home-solution--featured' : ''}`}
            data-reveal
            style={{ '--reveal-delay': `${index * 0.1}s` }}
          >
            <span className="home-icon-tile"><Icon name={item.icon} draw /></span>
            <span className="home-tag">{item.tag}</span>
            <h3>{item.title}</h3>
            {item.description && <p>{item.description}</p>}
            <ul>
              {item.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
            </ul>
            {item.featured && terminal && <TypingTerminal title={terminal.title} lines={terminal.lines} />}
            <span className="home-link-arrow">Explorar solución</span>
          </Link>
        ))}
      </div>
      <div className="home-swipe-ui">
        <span className="home-swipe-hint">Desliza</span>
        <div className="home-dots" role="group" aria-label="Elegir solución">
          {solutions.map((item, index) => (
            <button
              key={item.title}
              type="button"
              className={index === active ? 'is-active' : ''}
              aria-label={`Ver ${item.title}`}
              aria-pressed={index === active}
              onClick={() => goTo(index)}
            />
          ))}
        </div>
      </div>
    </>
  );
}
